import millenium from 'react95/dist/themes/millenium';

const qdeckTheme = {
  ...millenium,
  colors: {
    ...millenium.colors,
    amendmentOrange: '#F2994A'
  }
};

export default qdeckTheme;
